<template lang="pug">
  .crud
    .container-fluid
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between")
        vm-col.card__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-sm=12 vm-md=4 vm-lg=3)
          vm-row(vm-align="center" vm-type="flex" vm-justify="center")
            vm-col.title__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              h4.title Folio (OC)
            vm-col.information__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              h3.information # {{ folio }}
        vm-col.card__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-sm=12 vm-md=4 vm-lg=3)
          vm-row(vm-align="center" vm-type="flex" vm-justify="center")
            vm-col.title__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              h4.title Cliente
            vm-col.information__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              h3.information {{ customer }}
        vm-col.card__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-sm=12 vm-md=4 vm-lg=3)
          vm-row(vm-align="center" vm-type="flex" vm-justify="center")
            vm-col.title__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              h4.title Proveedor
            vm-col.information__wrapper(vm-align="center" vm-type="flex" vm-justify="center" vm-w="12")
              h3.information {{ supplier }}
      vm-tabs
        vm-tab(vm-label='Detalles de la Orden De Compra')
          vm-row(vm-w="12")
            vm-col.card(vm-sm=12)
              vm-table(max-height="350px" :data="detailsList")
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_orders_detail.' + column) }}
                  vm-th
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                      slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'product_id' && column != 'number_part'") {{data[indextr][column]}}
                      slot(v-if="column == 'status'") {{data[indextr]['status_display']}}
                      slot(v-if="column == 'product_id'") {{data[indextr]['product'].sku}} <br> {{data[indextr]['product'].name}}
                      slot(v-if="column == 'number_part'") {{data[indextr]['product'].number_part}}
                    vm-td
      vm-row(vm-w="12")
        supplier-shippment-component(:quotation_id="purchaseOrder.quotation ? purchaseOrder.quotation.id : ''" :supplier_id="purchaseOrder.supplier_id" :details="purchaseOrder.details")
        receptions-component(:quotation_id="purchaseOrder.quotation ? purchaseOrder.quotation.id : ''")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ReceptionsComponent from '@/components/receptions/ReceptionsComponent.vue'
import SupplierShippmentComponent from '@/components/receptions/SupplierShippmentComponent.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('Receptions')

export default {
  name: 'Receptions',
  components: {
    ReceptionsComponent,
    SupplierShippmentComponent
  },
  data: () => ({
    columns: [
      'quantity',
      'product_id',
      'number_part',
      'unit_price',
      'total'
    ]
  }),
  validations: {},
  computed: {
    ...mapGetters(['purchaseOrder']),
    detailsList () {
      let t = this
      return this.purchaseOrder.details.map(detail => {
        (parseFloat(detail.unit_price_raw) === 0.00) && (detail.unit_price_raw = detail.unit_price)
        if (detail.edit !== undefined && (parseInt(detail.product.currency_id) !== parseInt(t.purchaseOrder.currency_id))) {
          (parseInt(detail.product.currency_id) === 1 ? detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) * parseFloat(t.purchaseOrder.exchange_rate)).toFixed(2) : detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) / t.purchaseOrder.exchange_rate).toFixed(2))
        } else if (parseInt(detail.product.currency_id) !== parseInt(t.purchaseOrder.currency_id)) {
          (parseInt(detail.product.currency_id) === 1 ? detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) * parseFloat(t.purchaseOrder.exchange_rate)).toFixed(2) : detail.unit_price = parseFloat(parseFloat(detail.unit_price_raw) / t.purchaseOrder.exchange_rate).toFixed(2))
        } else {
          detail.unit_price = parseFloat(detail.unit_price_raw)
        }
        detail.subtotal = (parseFloat(detail.unit_price) * parseFloat(detail.quantity)).toFixed(2)
        detail.total = parseFloat(detail.subtotal)
        return detail
      })
    },
    customer () {
      if (this.purchaseOrder.customer) {
        return this.purchaseOrder.customer.tradename
      }
    },
    folio () {
      if (this.purchaseOrder.folio) {
        return this.purchaseOrder.folio
      }
    },
    supplier () {
      if (this.purchaseOrder.supplier.name) {
        return this.purchaseOrder.supplier.name
      }
    }
  },
  watch: {},
  async created () {
    await this.loadPurchaseOrder({ id: this.$route.params.id })
  },
  methods: {
    ...mapActions([
      'loadPurchaseOrder'
    ])
  }
}
</script>

<style lang="scss" scoped>

.card__wrapper {
  background-color: #026481;
  padding: 20px;
  border-radius: 0.5em;
  .title__wrapper {
    .title {
      font-size: 16px;
      color: #fff;
    }
  }

  .information__wrapper {
    .information {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
    }
  }
}

</style>
